module.exports = ".demo-chip-list {\n    width: 100%;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/modulos/categorias/categorias.component.css
// module id = ./src/app/modulos/categorias/categorias.component.css
// module chunks = main